export default class ToolBarUtil
{
	static createToolBarObj_Form_FormLookup()
	{
		var obj:Object = new Object();
		obj.Print = false;
		obj.Preview = false;
		obj.Export = false;
		obj.Da = false;
		obj.RecordNew = false;
		obj.RecordSave = false;
		obj.RecordDelete = false;
		obj.RecordRestore = true;
		obj.QueryOpen = true;
		obj.QueryRemove = false;
		obj.FindOpen = true;
		obj.Refresh = false;
		obj.CursorFirst = true;
		obj.CursorLast = true;
		obj.CursorPrev = true;
		obj.CursorNext = true;
		obj.CursorPrevPage = true;
		obj.CursorNextPage = true;
		obj.FetchAll = true;
		obj.Attachment = false;
		obj.WorkFlowDetail = true;
		obj.EditModeChange = true;
		obj.MainMenu = true;
		obj.GOT = true;
		obj.Help = true;
		//obj.ReInitForm = true;
		
		return obj;
	}

	static createToolBarObj_Default()
	{
		var obj:Object = new Object();
		obj.Print = false;
		obj.Preview = false;
		obj.Export = false;
		obj.Da = true;
		obj.RecordNew = false;
		obj.RecordSave = false;
		obj.RecordDelete = false;
		obj.RecordRestore = false;
		obj.QueryOpen = false;
		obj.QueryRemove = false;
		obj.FindOpen = false;
		obj.Refresh = false;
		obj.CursorFirst = false;
		obj.CursorLast = false;
		obj.CursorPrev = false;
		obj.CursorNext = false;
		obj.CursorPrevPage = false;
		obj.CursorNextPage = false;
		obj.FetchAll = false;
		obj.Attachment = false;
		obj.WorkFlowDetail = false;
		obj.EditModeChange = false;
		obj.MainMenu = true;
		obj.GOT = true;
		obj.Help = true;
		//obj.ReInitForm = true;
		
		return obj;
	}

	static setObjectExport(obj, enable=true)
	{
		obj.Print = enable;
		obj.Preview = enable;
		obj.Export = enable;
	}
	
	static setObjectPrint(obj, enable = true)
	{
		obj.Print = enable;
	}
	
	static getObjectPrint(obj)
	{
		if(obj)
			return obj.Print;
		return false;
	}
	
	static getObjectExport(obj)
	{
		if(obj)
			return obj.Export;
		return false;
	}
	
	static setObjectNew(obj, enable=true)
	{
		obj.RecordNew = enable;
	}
	
	static setObjectAttachment(obj,enable=true)
	{
		obj.Attachment = enable;
	}
	
	static getObjectAttachment(obj)
	{
		return obj.Attachment;
	}
	
	static getObjectNew(obj)
	{
		if(obj)
			return obj.RecordNew;
		return false;
	}
	
	static setObjectSave(obj, enable=true)
	{
		obj.RecordSave = enable;
	}
	
	static getObjectSave(obj)
	{
		if(obj)
			return obj.RecordSave;
		return false;
	}
	
	static setObjectDelete(obj, enable=true)
	{
		obj.RecordDelete = enable;
	}
	
	static getObjectDelete(obj)
	{
		if(obj)
			return obj.RecordDelete;
		return false;
	}
	
	static setObjectQueryRemove(obj, enable=true)
	{
		if(obj)
			obj.QueryRemove = enable;
	}
	
	static setObjectQuery(obj, enable=true)
	{
		
		obj.RecordRestore = enable;
		obj.QueryOpen = enable;
		if(!enable)
			obj.QueryRemove = enable;
		obj.FindOpen = enable;
		obj.Refresh = enable;
		this.setObjectCursorOpr(obj);
		obj.FetchAll = enable;
		obj.Attachment = enable;
		obj.WorkFlowDetail = enable;
	}
	
	static setObjectRestore(obj,enable=true)
	{
		obj.RecordRestore = enable;
	}

	static getObjectQuery(obj)
	{
		if(obj)
			return obj.QueryOpen;
		return false;
	}
		
	static setObjectCursorOpr(obj, enable=true)
	{
		obj.CursorFirst = enable;
		obj.CursorLast = enable;
		obj.CursorPrev = enable;
		obj.CursorNext = enable;
		obj.CursorPrevPage = enable;
		obj.CursorNextPage = enable;
	}

	static setObjectGroupNull(obj)
	{
		obj.Print = false;
		obj.Preview = false;
		obj.Export = false;
		
		obj.RecordNew = false;
		obj.RecordSave = false;
		obj.RecordDelete = false;
		
		obj.RecordRestore = false;
		obj.QueryOpen = false;
		
		obj.QueryRemove = false;
		obj.FindOpen = false;
		obj.CursorFirst = false;
		obj.CursorLast = false;
		obj.CursorPrev = false;
		obj.CursorNext = false;
		obj.CursorPrevPage = false;
		obj.CursorNextPage = false;
		obj.FetchAll = false;
		obj.Attachment = false;
		
		obj.Refresh = false;
	}
}


// WEBPACK FOOTER //
// ./src/utils/ToolBarUtil.js